<app-header></app-header>
<div class="home full-page">
    <app-service-button></app-service-button>

    <div class="carousel">
        <owl-carousel-o [options]="customOptions">
            <ng-container *ngFor="let photo of sales" class="banner-list">
                <ng-template class="photo" carouselSlide>
                    <img [src]="getPhotoUrl(photo?.url, photo?.urlResponsive)" >
                </ng-template>
            </ng-container>
        </owl-carousel-o>
    </div>

    <drag-scroll style="height: 110px;" drag-scroll-y-disabled="true" *ngIf="isInfoCardsLoaded" class="information-bar hiddenScroll">
        <div class="card small-info" *ngFor="let info of infoCards; index as i">
            <img [src]="info?.url" alt="info?.description">
            <span class="info-description">{{ 'home.' + info?.description | translate }}</span>
        </div>
        <div class="space">.</div>
    </drag-scroll>

    <div class="credit-letter" *ngIf="isLetterOfCreditEnabled">
        <div class="title-container">{{ 'home.creditLetterTitle' | translate}}</div>
        <div class="text-container">
            <div class="text-width">{{ 'home.creditLetterText' | translate}}</div>
            <img (click)="goToCreditLetter()" src="assets/images/letterofcredit_button.png" class="letter-button">
        </div>
    </div>

    <div class="best-sellers">
        <div class="container-title">
            <h1 class="section-title">{{ 'home.bestSellers' | translate }}</h1>
            <strong  (click)="goToCategory('')"  class="link">{{ 'home.seeAll' | translate }}</strong>
        </div>
        <drag-scroll class="card-list hiddenScroll" style="min-height: 413px; height: max-content" drag-scroll-y-disabled="true">
            <div class="card product-home" *ngFor="let product of bestSellers; let i =index" >
                <div class="sold-out centered" *ngIf="product.stock_amount === 0 || !getPrice(product?.prices)">
                    <span>{{ 'home.soldOut' | translate}}</span>
                </div>
                <div (click)="toggleFavorite(product?.id)" click-stop-propagation class="favorite-icon-container">
                    <mat-icon
                        [matTooltip]="(product?.isFavorite ? 'home.removeFavorite' : 'home.addFavorite') | translate" matTooltipClass="tooltip-primary"
                        fontSet="material-icons-round" class="favorite-icon"
                        [ngClass]="{'favorited': product.isFavorite }">
                            {{ product.isFavorite ? 'favorite' : 'favorite_border' }}
                    </mat-icon>
                </div>
                <div class="product-image" (click)="definingAction(product)" [style.background-image]="'url(' + getProductImage(product.midias) + ')'">
                    <img [src]="product?.waterMark" alt="watermark" class="watermark" *ngIf="product?.waterMark">
                </div>
                <div (click)="definingAction(product)" class="product-info">
                    <p class="product-name">{{ product?.name }}</p>
                    <div class="available-item" *ngIf="product.stock_amount > 0">
                        <div *ngIf="!isAdvertisement(product) || (isAdvertisement(product) && !hideAdvertisementPrice)" style="display: flex;">
                            <p class="price"  onselectstart="return false">{{ product?.price | currency:'BRL':true:'1.2-2' }}</p>
                            <p class="old-price" *ngIf="getOldPrice(product?.prices) && product.discount" onselectstart="return false">{{ product?.oldPrice | currency:'BRL':true:'1.2-2' }}</p>
                        </div>
                        <div *ngIf="hideAdvertisementPrice && isAdvertisement(product)" style="display: flex;">
                            <p class="price"  onselectstart="return false">{{ 'productDetails.knowMore' | translate }}</p>
                        </div>
                        <div class="bottom-container" onselectstart="return false">
                            <!-- When the product isn't in stock, it makes no sense to be free shipping -->
                            <div class="free-shipping" *ngIf="product.freeShipping && !(product.stock_amount === 0 || !getPrice(product?.prices))">
                                <mat-icon fontSet="material-icons-round">local_shipping</mat-icon>
                                <span>{{ 'home.freeShipping' | translate }}</span>
                            </div>
                            <div class="discount" *ngIf="getPrice(product?.prices) && product.discount && (!isAdvertisement(product) || (isAdvertisement(product) && !hideAdvertisementPrice))">
                                <strong>-{{ product?.discount | currency:'BRL':true:'1.2-2'}}</strong>
                            </div>
                        </div>
                    </div>
                    <div class="unavailable-item" *ngIf="product.stock_amount === 0 || !getPrice(product?.prices)"  onselectstart="return false">
                        <p>{{ 'home.unavailableItem' | translate}}</p>
                    </div>
                </div>
            </div>
        </drag-scroll>
    </div>

    <div class="featured-categories">
        <div class="container-title">
            <h1 class="section-title">{{ 'home.featuredCategories' | translate }}</h1>
            <strong (click)="searchAllCategories()" class="link">{{ 'home.seeAll' | translate }}</strong>
        </div>
        <drag-scroll class="categories-list hiddenScroll" style="height: 195px;" drag-scroll-y-disabled="true" onselectstart="return false">
            <div class="category-item" *ngFor="let item of featuredCategories" (click)="searchCategory(item?.id, item?.name)">
                <img [src]="item?.image_url" [alt]="item?.name">
                <span class="category-name">{{ item?.name }}</span>
            </div>
        </drag-scroll>
    </div>

    <div class="advertising-banner">
        <div class="int">
            <div class="social-help card" *ngIf="isSocialBannerEnabled">
                <div class="info">
                    <h1 class="title">{{ 'home.helpFamily' | translate }}</h1>
                    <p>{{ 'home.helpText' | translate }}</p>

                    <button (click)="goToUrl('social')" class="banner-know-more">{{ 'home.knowMore' | translate }}</button>
                </div>
                <img src="https://www.uninassau.edu.br/sites/mauriciodenassau.edu.br/files/fields/imagemLateral/noticias/2018/09/253ccd1fcab6bd4c5a12eea534398.jpg" alt="doação">
            </div>

            <div class="news-email card" *ngIf="loggedUser">
                <div class="header inline-vertical-align">
                    <mat-icon fontSet="material-icons-round">email</mat-icon>
                    <h1 class="title">{{ 'home.receiveEmail' | translate }}</h1>
                </div>
                <div class="bottom inline-vertical-align" >
                    <input class="input etc" [(ngModel)]="email" type="text" [placeholder]="'home.insertEmail' | translate">
                    <button class="btn default" (click)="receiveNewsLetter()">{{ 'button.confirm' | translate }}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="releases">
        <div class="container-title">
            <h1 class="section-title">{{ 'home.releases' | translate }}</h1>
            <strong (click)="goToCategory('')" class="link">{{ 'home.seeAll' | translate }}</strong>
        </div>
        <drag-scroll class="card-list hiddenScroll" style="height: 162px;" drag-scroll-y-disabled="true">
            <div class="space">.</div>
            <div class="card landscape-card" *ngFor="let product of releases; let i =index" (click)="goToDetails(product?.id)">
                <div class="product-image" [style.background-image]="'url(' + getProductImage(product.midias) + ')'">
                    <img [src]="product?.waterMark" alt="watermark" class="watermark" *ngIf="product?.waterMark">
                </div>
                <div class="product-info">
                    <p class="product-name">{{ product?.name }}</p>
                    <div  *ngIf="!isAdvertisement(product) || (isAdvertisement(product) && !hideAdvertisementPrice)" style="display: flex;">
                        <p class="price" onselectstart="return false">{{ product?.price | currency:'BRL':true:'1.2-2' }}</p>
                    </div>

                    <div *ngIf="hideAdvertisementPrice && isAdvertisement(product)" style="display: flex;">
                        <p class="price"  onselectstart="return false">{{ 'productDetails.knowMore' | translate }}</p>
                    </div>

                    <div class="discount-row" *ngIf="product?.oldPrice && product?.discount && !hideAdvertisementPrice">
                        <p class="old-price">{{ product?.oldPrice | currency:'BRL':true:'1.2-2'}}</p>
                        <mat-icon [matTooltip]="'- ' + valueConverter.convertToMonetaryFormat(product.discount, 'R$')" 
                                matTooltipClass="tooltip-primary" class="tag-content">local_offer</mat-icon>
                    </div>

                    <div class="bottom-container" onselectstart="return false">
                        <div class="free-shipping" *ngIf="product.freeShipping">
                            <mat-icon fontSet="material-icons-round">local_shipping</mat-icon>
                            <span>{{ 'home.freeShipping' | translate }}</span>
                        </div>

                        <mat-icon
                            [matTooltip]="(product?.isFavorite ? 'home.removeFavorite' : 'home.addFavorite') | translate" matTooltipClass="tooltip-primary"
                            click-stop-propagation
                            (click)="toggleFavorite(product?.id)"
                            fontSet="material-icons-round" class="favorite-icon gray"
                            [ngClass]="{'favorited': product.isFavorite }">
                                {{ product.isFavorite ? 'favorite' : 'favorite_border' }}
                        </mat-icon>
                    </div>
                </div>
            </div>
            <div class="space">.</div>
        </drag-scroll>
    </div>
    <mat-progress-spinner *ngIf="loading" class="spinner" [mode]="'indeterminate'"></mat-progress-spinner>
</div>
